module.exports = __webpack_public_path__ + "media/application/images/process_steps/bookstack_02-739115e9f4f725a247aeb0c48a47c17e.png";